import {
    faAngleLeft,
    faDownload,
    faPaperclip,
    faPlus,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "react-bootstrap";
import { connect } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import "../../assets/css/Care-Registration.css";
import Footer from "../../components/Footer";
import Header from "../../components/Header";
import config from "../../config";
import { CreateProfileAction } from "../../redux/actions/auth";
import useQuery from "../../useQuery";

const CareRegistration3 = ({ auth, states, createProfile }) => {
    const navigate = useNavigate();

    const [profileImageSrc, setProfileImageSrc] = useState(null);
    const [profilePicture, setProfilePicture] = useState(null);
    const [firstName, setFirstName] = useState(auth.user.first_name || "");
    const [lastName, setLastName] = useState(auth.user.last_name || "");
    const [email, setEmail] = useState(auth.user.email);
    const [addressLine1, setAddressLine1] = useState(auth.user.address_1 || "");
    const [addressLine2, setAddressLine2] = useState(auth.user.address_2 || "");
    const [city, setCity] = useState(auth.user.city || "");
    const [state, setState] = useState(auth.user.state || "");
    const [zip, setZip] = useState(auth.user.zip || "");
    const [dobDate, setDobDate] = useState("");
    const [dobMonth, setDobMonth] = useState("");
    const [dobYear, setDobYear] = useState("");
    const [dob, setDob] = useState(null);
    const [maxDistance, setMaxDistance] = useState(
        auth.user.max_distance || ""
    );
    const [phoneNo, setPhoneNo] = useState(auth.user.phone_no || "");
    const [emergencyContactName, setEmergencyContactName] = useState(
        auth.user.emergency_name || ""
    );
    const [emergencyContactNo, setEmergencyContactNo] = useState(
        auth.user.emergency_mobile_number || ""
    );
    const [emergencyNames, setEmergencyNames] = useState("");
    const [experience, setExperience] = useState([{ field: "", year: "" }]);
    const [fewLines, setFewLines] = useState(auth.user.few_lines || "");
    const [documents, setDocuments] = useState([]);
    const [privacyAccept1, setPrivacyAccept1] = useState(false);
    const [holdHarmless, setHoldHarmless] = useState("");
    const [photoRelease, setPhotoRelease] = useState("");
    const [holdHarmlessAccept, setHoldHarmlessAccept] = useState(false);
    const [photoReleaseAccept, setPhotoReleaseAccept] = useState(false);
    const [holdHarmlessModal, setHoldHarmlessModal] = useState(false);
    const [photoReleaseModal, setPhotoReleaseModal] = useState(false);
    // const [privacyAccept2, setPrivacyAccept2] = useState(false);

    const query = useQuery();

    const onProfileChange = (e) => {
        setProfilePicture(e.target.files[0]);
        let fr = new FileReader();
        fr.onload = function (ee) {
            setProfileImageSrc(ee.target.result);
        };
        fr.onerror = () => {
            setProfilePicture(null);
            setProfileImageSrc(null);
        };
        fr.readAsDataURL(e.target.files[0]);
    };

    const addExp = () => {
        let newExperience = [...experience];
        if (newExperience.length == 3) {
            return false;
        } else {
            newExperience.push({ field: "", year: "" });
            setExperience(newExperience);
        }
    };

    const onExpFieldChange = (index, field) => {
        const newExp = [...experience];
        newExp[index].field = field;
        setExperience(newExp);
    };

    const onExpYearChange = (index, year) => {
        const newExp = [...experience];
        newExp[index].year = year;
        setExperience(newExp);
    };

    const onDocsChange = (e) => {
        setDocuments([...e.target.files]);
    };

    const submit = async () => {
        try {
            if (!privacyAccept1) {
                return Swal.fire({
                    icon: "error",
                    title: "Accept Privacy",
                    text: "You need to Accept Prvacy Policies of Contact Information in order to continue!",
                });
            }
            if (!holdHarmlessAccept) {
                return Swal.fire({
                    icon: "error",
                    title: "Accept Hold Harless Agreement",
                    text: "You need to Accept Hold Harmless Agreement in order to continue!",
                });
            }
            if (!photoReleaseAccept) {
                return Swal.fire({
                    icon: "error",
                    title: "Accept Photo Release Agreement",
                    text: "You need to Accept Photo Release Agreement in order to continue!",
                });
            }
            if (firstName.length <= 1) {
                return Swal.fire({
                    text: "First name must be of atleast 2 alpha characters",
                    title: "Oh Snap!",
                    icon: "error",
                });
            }
            if (lastName.length <= 1) {
                return Swal.fire({
                    text: "Last name must be of atleast 2 alpha characters",
                    title: "Oh Snap!",
                    icon: "error",
                });
            }

            let formdata = new FormData();
            formdata.append("first_name", firstName);
            formdata.append("last_name", lastName);
            formdata.append("avatar", profilePicture);
            formdata.append("address_1", addressLine1);
            formdata.append("address_2", addressLine2);
            formdata.append("city", city);
            formdata.append("state", state);
            formdata.append("zip", zip);
            formdata.append("dob", dob);
            // formdata.append("dob_date", dobDate);
            // formdata.append("dob_month", dobMonth);
            // formdata.append("dob_year", dobYear);
            formdata.append("max_distance", maxDistance);
            formdata.append("phone_no", phoneNo);
            formdata.append("emergency_name", emergencyContactName);
            formdata.append("emergency_mobile_number", emergencyContactNo);
            // formdata.append("emergency_members_name", emergencyNames);
            // experience.map((exp, index) => {
            //     formdata.append(`experience[${index}][year]`, exp.year);
            //     formdata.append(`experience[${index}][field]`, exp.field);
            // });
            documents.map((doc, index) => {
                formdata.append(`documents[${index}]`, doc);
            });
            formdata.append("few_lines", fewLines);
            createProfile(formdata).then(() => {
                // if (auth.user.experience.length > 0) {
                navigate("/care-giver-registration-4?back=true");
                // }
            });
        } catch (e) {
            console.log(e);
        }
    };

    useEffect(() => {
        getPages();
        if (auth.user.dob) {
            setDob(auth.user.dob);
            let breakedDob = auth.user.dob.split("-");

            setDobYear(breakedDob[0].toString().padStart(2, "0"));
            setDobMonth(breakedDob[1].toString().padStart(2, "0"));
            setDobDate(breakedDob[2].toString().padStart(2, "0"));
        }
        if (!query.get("back")) {
            // if (auth.user.experience.length > 0) {
            navigate("/care-giver-registration-4?back=true");
            // }
        } else {
            // console.log("acb");
        }
    }, []);

    const getPages = async () => {
        try {
            const headers = config.bearerHeaders(auth.token);
            const res = await config.getApi(config.services.pages(), headers);
            if (res) {
                let holdHarmlessLocal = res.response.data.filter(
                    (singlePage) => singlePage.slug == "hold-harmless-agreement"
                );
                let photoReleaseLocal = res.response.data.filter(
                    (singlePage) => singlePage.slug == "photo-release-agreement"
                );
                if (holdHarmlessLocal.length > 0) {
                    setHoldHarmless(holdHarmlessLocal[0].content);
                }
                if (photoReleaseLocal.length > 0) {
                    // console.log(photoReleaseLocal[0].content);
                    setPhotoRelease(photoReleaseLocal[0].content);
                }
            }
        } catch (e) {
            console.log(e);
        }
    };
    // useEffect(() => {
    //     if (!query.get("back")) {
    //         if (auth.user.experience.length > 0) {
    //             navigate("/care-giver-registration-4");
    //         }
    //     }
    // }, [auth]);

    return (
        <>
            <Header />
            {/* <!-- Care Giver Registration Form --> */}
            <div className="care-registration">
                <div className="container">
                    <div className="top_bar">
                        <div className="heading_wrapper">
                            <h2>Care Giver Registration</h2>
                            <p>
                                You can register and connect with a specialist
                                caregiver or home-helper by following our 5-step
                                easy process.
                            </p>
                        </div>
                        <div className="tab_nav" role="tablist">
                            <span className="borderTop"></span>
                            <ul
                                className="navs nav-tabs"
                                id="myTab"
                                role="tablist"
                            >
                                <li className="nav-item">
                                    <span className="count">1</span>
                                    <h6>Service Selection</h6>
                                </li>

                                <li className="nav-item">
                                    <span className="count">2</span>
                                    <h6>Service Setup</h6>
                                </li>
                                <li className="nav-item active">
                                    <span className="count">3</span>
                                    <h6>Build Trust</h6>
                                </li>
                                <li className="nav-item">
                                    <span className="count">4</span>
                                    <h6>Finalization</h6>
                                </li>
                                <li className="nav-item">
                                    <span className="count">5</span>
                                    <h6>Payment</h6>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div id="wizard">
                        <h6>Third</h6>
                        <div className="bottom_bar">
                            <div className="note">
                                <p>
                                    Note: service providers (e.g. sitters) must
                                    abide by applicable laws and regulations.{" "}
                                    <Link
                                        to="/privacy-policy"
                                        color={config.primaryColor}
                                    >
                                        Privacy Policy
                                    </Link>
                                </p>
                            </div>
                            <div className="button-group">
                                <button
                                    type="button"
                                    className="btn mr-1"
                                    onClick={() =>
                                        navigate(
                                            "/care-giver-registration-2?back=true"
                                        )
                                    }
                                >
                                    Back
                                </button>
                                <button
                                    className="btn"
                                    onClick={() => navigate("/")}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="btn ml-2"
                                    onClick={submit}
                                >
                                    Save &amp; Continue
                                </button>
                            </div>
                        </div>
                        <section id="tabcontent" className="third_tab">
                            <div className="head_wrapper">
                                <h5>Build Trust</h5>
                                <p>
                                    Select Services you want to provide .You can
                                    select multiple service
                                </p>
                            </div>
                            <div id="accordionTwo">
                                {/* <form action="" id="" method="POST" onSubmit={submit} > */}
                                <div className="card">
                                    <div className="card-header" id="formfour">
                                        <h5 className="mb-0">
                                            <button
                                                type="button"
                                                className="btn btn-link"
                                                data-toggle="collapse"
                                                data-target="#formfourcollapse"
                                                aria-expanded="true"
                                                aria-controls="formfourcollapse"
                                            >
                                                <div className="care_dropdown">
                                                    <div className="header_bar">
                                                        <div className="icon_bar">
                                                            <h5 className="title">
                                                                Basic
                                                                Information
                                                            </h5>
                                                        </div>
                                                        <div className="ques">
                                                            <p>
                                                                Provide your
                                                                personally
                                                                identifiable
                                                                information.
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <div className="drop">
                                                        <FontAwesomeIcon
                                                            icon={faAngleLeft}
                                                        />
                                                    </div>
                                                </div>
                                            </button>
                                        </h5>
                                    </div>
                                    <div
                                        id="formfourcollapse"
                                        className="collapse show"
                                        aria-labelledby="formfour"
                                        data-parent="#accordionTwo"
                                    >
                                        <div className="card-body">
                                            <div className="row">
                                                <div className="col-lg-10">
                                                    <div className="row align-items-center">
                                                        <div className="col-md-5">
                                                            <div className="form-group">
                                                                <label htmlFor="profile">
                                                                    Profile
                                                                    Picture{" "}
                                                                    <span className="req">
                                                                        *
                                                                    </span>
                                                                </label>
                                                                <div className="buttons">
                                                                    <button type="button">
                                                                        <i
                                                                            className="fa fa-camera"
                                                                            aria-hidden="true"
                                                                        ></i>
                                                                        Upload
                                                                        an Image
                                                                    </button>
                                                                    <input
                                                                        accept="image/*"
                                                                        type="file"
                                                                        id="profile"
                                                                        className="form-control"
                                                                        onChange={
                                                                            onProfileChange
                                                                        }
                                                                    />
                                                                    {/* <!--                                                            <input className="form-control" type="file" id="profile" placeholder="Accep png,jpg,pdf,doc,docs">--> */}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-5">
                                                            <div className="note">
                                                                <p>
                                                                    <span>
                                                                        Note:
                                                                    </span>
                                                                    This is the
                                                                    first photo
                                                                    Client will
                                                                    see. We
                                                                    recommend
                                                                    using a
                                                                    well-lit,
                                                                    clear photo
                                                                    of your face
                                                                    (without
                                                                    sunglasses).
                                                                </p>
                                                            </div>
                                                            <img
                                                                className="circle"
                                                                src={
                                                                    profileImageSrc
                                                                }
                                                            />
                                                            {/* <span className="circle"></span> */}
                                                        </div>
                                                        <div className="col-md-2"></div>
                                                        <div className="col-md-6">
                                                            <div className="form-group">
                                                                <label htmlFor="fname">
                                                                    First name{" "}
                                                                    <span className="req">
                                                                        *
                                                                    </span>
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    id="fName"
                                                                    className="form-control"
                                                                    placeholder="Enter Your First Name"
                                                                    value={
                                                                        firstName
                                                                    }
                                                                    onChange={(
                                                                        e
                                                                    ) =>
                                                                        setFirstName(
                                                                            e
                                                                                .target
                                                                                .value
                                                                        )
                                                                    }
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="form-group">
                                                                <label htmlFor="lname">
                                                                    Last name{" "}
                                                                    <span className="req">
                                                                        *
                                                                    </span>
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    id="lastName"
                                                                    className="form-control"
                                                                    placeholder="Enter Your Last Name"
                                                                    value={
                                                                        lastName
                                                                    }
                                                                    onChange={(
                                                                        e
                                                                    ) =>
                                                                        setLastName(
                                                                            e
                                                                                .target
                                                                                .value
                                                                        )
                                                                    }
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="form-group">
                                                                <label htmlFor="email">
                                                                    Email{" "}
                                                                    <span className="req">
                                                                        *
                                                                    </span>
                                                                </label>
                                                                <input
                                                                    type="email"
                                                                    id="email"
                                                                    className="form-control"
                                                                    placeholder="John@gmail.com"
                                                                    value={
                                                                        email
                                                                    }
                                                                    onChange={(
                                                                        e
                                                                    ) =>
                                                                        setEmail(
                                                                            e
                                                                                .target
                                                                                .value
                                                                        )
                                                                    }
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="note">
                                                                <p>
                                                                    Note: You
                                                                    will receive
                                                                    confirmation
                                                                    email on you
                                                                    registered
                                                                    email to
                                                                    update email
                                                                    address
                                                                </p>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-12">
                                                            <div className="form-group">
                                                                <label htmlFor="address1">
                                                                    Address line
                                                                    1{" "}
                                                                    <span className="req">
                                                                        *
                                                                    </span>
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    id="addressStreet"
                                                                    className="form-control"
                                                                    placeholder="Enter Your Address (Apartment, Building, Street#)"
                                                                    value={
                                                                        addressLine1
                                                                    }
                                                                    onChange={(
                                                                        e
                                                                    ) =>
                                                                        setAddressLine1(
                                                                            e
                                                                                .target
                                                                                .value
                                                                        )
                                                                    }
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-12">
                                                            <div className="form-group">
                                                                <label htmlFor="address2">
                                                                    Address line
                                                                    2
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    id="address2"
                                                                    className="form-control"
                                                                    placeholder="Enter Your Address"
                                                                    value={
                                                                        addressLine2
                                                                    }
                                                                    onChange={(
                                                                        e
                                                                    ) =>
                                                                        setAddressLine2(
                                                                            e
                                                                                .target
                                                                                .value
                                                                        )
                                                                    }
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <div className="form-group">
                                                                <label htmlFor="city">
                                                                    City{" "}
                                                                    <span className="req">
                                                                        *
                                                                    </span>
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    id="city"
                                                                    className="form-control"
                                                                    placeholder="Enter Your Address (Apartment, Building, Street#)"
                                                                    value={city}
                                                                    onChange={(
                                                                        e
                                                                    ) =>
                                                                        setCity(
                                                                            e
                                                                                .target
                                                                                .value
                                                                        )
                                                                    }
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <div className="form-group">
                                                                <label htmlFor="state">
                                                                    State/Provice{" "}
                                                                    <span className="req">
                                                                        *
                                                                    </span>
                                                                </label>
                                                                <select
                                                                    className="form-control"
                                                                    value={
                                                                        state
                                                                    }
                                                                    onChange={(
                                                                        e
                                                                    ) =>
                                                                        setState(
                                                                            e
                                                                                .target
                                                                                .value
                                                                        )
                                                                    }
                                                                >
                                                                    <option
                                                                        value={
                                                                            null
                                                                        }
                                                                    >
                                                                        Select
                                                                        State
                                                                    </option>
                                                                    {states.map(
                                                                        (
                                                                            singleState
                                                                        ) => (
                                                                            <option
                                                                                key={
                                                                                    singleState.id
                                                                                }
                                                                                value={
                                                                                    singleState.id
                                                                                }
                                                                            >
                                                                                {
                                                                                    singleState.name
                                                                                }
                                                                            </option>
                                                                        )
                                                                    )}
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <div className="form-group">
                                                                <label htmlFor="zip">
                                                                    Zip/postal/Postcode{" "}
                                                                    <span className="req">
                                                                        *
                                                                    </span>
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    id="zip"
                                                                    placeholder="Your Zip/Postal Code"
                                                                    value={zip}
                                                                    onChange={(
                                                                        e
                                                                    ) =>
                                                                        setZip(
                                                                            e
                                                                                .target
                                                                                .value
                                                                        )
                                                                    }
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-12">
                                                            <div className="form-group">
                                                                <label htmlFor="dob">
                                                                    Date of
                                                                    Birth
                                                                </label>
                                                                <input
                                                                    type="date"
                                                                    className="form-control"
                                                                    id="dob"
                                                                    value={dob}
                                                                    onChange={(
                                                                        e
                                                                    ) =>
                                                                        setDob(
                                                                            e
                                                                                .target
                                                                                .value
                                                                        )
                                                                    }
                                                                />
                                                            </div>
                                                        </div>
                                                        {/* <div className="col-md-4">
                                                            <div className="form-group">
                                                                <label htmlFor="birth">
                                                                    Date of
                                                                    Birth(Day){" "}
                                                                    <span className="req">
                                                                        *
                                                                    </span>
                                                                </label>
                                                                <select
                                                                    className="form-control"
                                                                    id="dob_date"
                                                                    onChange={(
                                                                        e
                                                                    ) =>
                                                                        setDobDate(
                                                                            e
                                                                                .target
                                                                                .value
                                                                        )
                                                                    }
                                                                    value={
                                                                        dobDate
                                                                    }
                                                                >
                                                                    <option
                                                                        value={
                                                                            null
                                                                        }
                                                                    >
                                                                        Select
                                                                        Day
                                                                    </option>
                                                                    {new Array(
                                                                        31
                                                                    )
                                                                        .fill()
                                                                        .map(
                                                                            (
                                                                                a,
                                                                                date
                                                                            ) => (
                                                                                <option>
                                                                                    {(
                                                                                        date +
                                                                                        1
                                                                                    )
                                                                                        .toString()
                                                                                        .padStart(
                                                                                            2,
                                                                                            "0"
                                                                                        )}
                                                                                </option>
                                                                            )
                                                                        )}
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <div className="form-group">
                                                                <label htmlFor="birth">
                                                                    Date of
                                                                    Birth(Month){" "}
                                                                    <span className="req">
                                                                        *
                                                                    </span>
                                                                </label>
                                                                <select
                                                                    className="form-control"
                                                                    id="dob_month"
                                                                    onChange={(
                                                                        e
                                                                    ) =>
                                                                        setDobMonth(
                                                                            e
                                                                                .target
                                                                                .value
                                                                        )
                                                                    }
                                                                    value={
                                                                        dobMonth
                                                                    }
                                                                >
                                                                    <option
                                                                        value={
                                                                            null
                                                                        }
                                                                    >
                                                                        Select
                                                                        Month
                                                                    </option>
                                                                    {new Array(
                                                                        12
                                                                    )
                                                                        .fill()
                                                                        .map(
                                                                            (
                                                                                a,
                                                                                date
                                                                            ) => (
                                                                                <option
                                                                                    value={(
                                                                                        date +
                                                                                        1
                                                                                    )
                                                                                        .toString()
                                                                                        .padStart(
                                                                                            2,
                                                                                            "0"
                                                                                        )}
                                                                                >
                                                                                    {moment(
                                                                                        date +
                                                                                            1,
                                                                                        "M"
                                                                                    ).format(
                                                                                        "MMMM"
                                                                                    )}
                                                                                </option>
                                                                            )
                                                                        )}
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <div className="form-group">
                                                                <label htmlFor="birth">
                                                                    Date of
                                                                    Birth(Year){" "}
                                                                    <span className="req">
                                                                        *
                                                                    </span>
                                                                </label>
                                                                <select
                                                                    className="form-control"
                                                                    id="dob_year"
                                                                    value={
                                                                        dobYear
                                                                    }
                                                                    onChange={(
                                                                        e
                                                                    ) =>
                                                                        setDobYear(
                                                                            e
                                                                                .target
                                                                                .value
                                                                        )
                                                                    }
                                                                >
                                                                    <option
                                                                        value={
                                                                            null
                                                                        }
                                                                    >
                                                                        Select
                                                                        Year
                                                                    </option>
                                                                    {new Array(
                                                                        40
                                                                    )
                                                                        .fill()
                                                                        .map(
                                                                            (
                                                                                a,
                                                                                year
                                                                            ) => (
                                                                                <option
                                                                                    key={
                                                                                        parseInt(
                                                                                            moment().format(
                                                                                                "YYYY"
                                                                                            )
                                                                                        ) -
                                                                                        (year +
                                                                                            18)
                                                                                    }
                                                                                >
                                                                                    {parseInt(
                                                                                        moment().format(
                                                                                            "YYYY"
                                                                                        )
                                                                                    ) -
                                                                                        (year +
                                                                                            18)}
                                                                                </option>
                                                                            )
                                                                        )}
                                                                </select>
                                                            </div>
                                                        </div> */}
                                                        <div className="col-md-12">
                                                            <div className="form-group">
                                                                <label htmlFor="distance">
                                                                    What is the
                                                                    Maximum
                                                                    Distance you
                                                                    will travel
                                                                    to get to
                                                                    the client's
                                                                    Home in
                                                                    Miles{" "}
                                                                    <span className="req">
                                                                        *
                                                                    </span>
                                                                </label>
                                                                <input
                                                                    type="number"
                                                                    className="form-control"
                                                                    id="max_distance"
                                                                    placeholder="Add Distance in miles"
                                                                    value={
                                                                        maxDistance
                                                                    }
                                                                    onChange={(
                                                                        e
                                                                    ) =>
                                                                        setMaxDistance(
                                                                            e
                                                                                .target
                                                                                .value
                                                                        )
                                                                    }
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-lg-2"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="card">
                                    <div className="card-header" id="formfive">
                                        <h5 className="mb-0">
                                            <button
                                                type="button"
                                                className="btn btn-link"
                                                data-toggle="collapse"
                                                data-target="#formfivecollapse"
                                                aria-expanded="false"
                                                aria-controls="formfivecollapse"
                                            >
                                                <div className="care_dropdown">
                                                    <div className="header_bar">
                                                        <div className="icon_bar">
                                                            <h5 className="title">
                                                                Phone Numbers
                                                            </h5>
                                                        </div>
                                                        <div className="ques">
                                                            <p>
                                                                Accurate contact
                                                                information will
                                                                help us connect
                                                                with you in
                                                                time.
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <div className="drop">
                                                        <FontAwesomeIcon
                                                            icon={faAngleLeft}
                                                        />
                                                    </div>
                                                </div>
                                            </button>
                                        </h5>
                                    </div>
                                    <div
                                        id="formfivecollapse"
                                        className="collapse"
                                        aria-labelledby="formfive"
                                        data-parent="#accordionTwo"
                                    >
                                        <div className="card-body">
                                            <div className="row align-items-center">
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label htmlFor="telephone">
                                                            Telephone{" "}
                                                            <span className="req">
                                                                *
                                                            </span>
                                                        </label>
                                                        <br />
                                                        <input
                                                            id="phone_no"
                                                            className="form-control"
                                                            type="tel"
                                                            // value={phoneNo}
                                                            // onChange={(e) =>
                                                            //     setPhoneNo(
                                                            //         e.target
                                                            //             .value
                                                            //     )
                                                            // }

                                                            value={phoneNo}
                                                            maxLength={11}
                                                            onChange={(e) => {
                                                                if (
                                                                    e.target
                                                                        .value !=
                                                                    ""
                                                                ) {
                                                                    if (
                                                                        /^[0-9]+$/.test(
                                                                            e
                                                                                .target
                                                                                .value
                                                                        )
                                                                    ) {
                                                                        setPhoneNo(
                                                                            e
                                                                                .target
                                                                                .value
                                                                        );
                                                                    }
                                                                } else {
                                                                    setPhoneNo(
                                                                        ""
                                                                    );
                                                                }
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="note">
                                                        <p>
                                                            <span>Note:</span> A
                                                            verified phone
                                                            number to keep your
                                                            account safe and for
                                                            important updates.
                                                            We'll send a code
                                                            via text message.
                                                        </p>
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label htmlFor="econtact1">
                                                            Emergency Contact
                                                            Name
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            id="emergency_name"
                                                            placeholder="Enter Emergency Contact Name"
                                                            value={
                                                                emergencyContactName
                                                            }
                                                            onChange={(e) => {
                                                                if (
                                                                    e.target
                                                                        .value !=
                                                                    ""
                                                                ) {
                                                                    if (
                                                                        /[a-z]/i.test(
                                                                            e
                                                                                .target
                                                                                .value
                                                                        )
                                                                    ) {
                                                                        setEmergencyContactName(
                                                                            e
                                                                                .target
                                                                                .value
                                                                        );
                                                                    }
                                                                } else {
                                                                    setEmergencyContactName(
                                                                        ""
                                                                    );
                                                                }
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label htmlFor="ephone">
                                                            Emergency Contact
                                                            Number
                                                        </label>
                                                        <br />
                                                        <input
                                                            id="emergency_mobile_no"
                                                            className="form-control"
                                                            type="tel"
                                                            value={
                                                                emergencyContactNo
                                                            }
                                                            maxLength={11}
                                                            onChange={(e) => {
                                                                if (
                                                                    e.target
                                                                        .value !=
                                                                    ""
                                                                ) {
                                                                    if (
                                                                        /^[0-9]+$/.test(
                                                                            e
                                                                                .target
                                                                                .value
                                                                        )
                                                                    ) {
                                                                        setEmergencyContactNo(
                                                                            e
                                                                                .target
                                                                                .value
                                                                        );
                                                                    }
                                                                } else {
                                                                    setEmergencyContactNo(
                                                                        ""
                                                                    );
                                                                }
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                                {/* <div className="col-md-12">
                                                        <div className="form-group">
                                                            <label htmlFor="members">
                                                                Please list all
                                                                members of your
                                                                household who
                                                                are authorized
                                                                to speak to us
                                                                in case of an
                                                                emergency.
                                                            </label>
                                                            <input
                                                                type="text"
                                                                id="emergency_members_name"
                                                                className="form-control"
                                                                placeholder="Enter Your First Name"
                                                                value={
                                                                    emergencyNames
                                                                }
                                                                onChange={(e) =>
                                                                    setEmergencyNames(
                                                                        e.target
                                                                            .value
                                                                    )
                                                                }
                                                            />
                                                        </div>
                                                    </div> */}
                                                <div className="col-md-12">
                                                    <div className="form-group d-flex acceptPolicy">
                                                        <input
                                                            type="checkbox"
                                                            id="accept_privacy"
                                                            style={{
                                                                marginTop: 5,
                                                            }}
                                                            value={
                                                                privacyAccept1
                                                            }
                                                            onChange={(e) =>
                                                                setPrivacyAccept1(
                                                                    e.target
                                                                        .checked
                                                                )
                                                            }
                                                            // className="form-control"
                                                        />
                                                        <label
                                                            className="pl-2"
                                                            htmlFor="accept_privacy"
                                                        >
                                                            By adding your phone
                                                            number, you’re
                                                            saying it’s okay for
                                                            us to send you
                                                            service–related text
                                                            messages, including
                                                            autodialed. You can
                                                            adjust these
                                                            settings anytime on
                                                            the Notifications
                                                            Preferences page.
                                                            Reply HELP for help
                                                            and STOP to
                                                            unsubscribe. Message
                                                            frequency varies.
                                                            Message and data
                                                            rates may apply. For
                                                            more, see our Terms
                                                            of Service and
                                                            Privacy Statement.
                                                            <span className="req">
                                                                *
                                                            </span>
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="card">
                                    <div className="card-header" id="formsix">
                                        <h5 className="mb-0">
                                            <button
                                                type="button"
                                                className="btn btn-link"
                                                data-toggle="collapse"
                                                data-target="#formsixcollapse"
                                                aria-expanded="false"
                                                aria-controls="formsixcollapse"
                                            >
                                                <div className="care_dropdown">
                                                    <div className="header_bar">
                                                        <div className="icon_bar">
                                                            <h5 className="title">
                                                                Details &amp;
                                                                Experience
                                                            </h5>
                                                        </div>
                                                        <div className="ques">
                                                            <p>
                                                                Sharing your
                                                                relevant
                                                                experience in
                                                                this industry
                                                                increases your
                                                                chances of
                                                                getting the gig
                                                                of your desire.
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <div className="drop">
                                                        <FontAwesomeIcon
                                                            icon={faAngleLeft}
                                                        />
                                                    </div>
                                                </div>
                                            </button>
                                        </h5>
                                    </div>
                                    <div
                                        id="formsixcollapse"
                                        className="collapse"
                                        aria-labelledby="formsix"
                                        data-parent="#accordionTwo"
                                    >
                                        <div className="card-body">
                                            <div className="row">
                                                {/* <div className="col-md-3">
                                                        <div className="form-group experienceDv">
                                                            <label htmlFor="experience">
                                                                Year of
                                                                Experience
                                                            </label>
                                                            {experience.map(
                                                                (
                                                                    exp,
                                                                    index
                                                                ) => (
                                                                    <input
                                                                        key={`exp_${index}`}
                                                                        type="text"
                                                                        id="experience_year"
                                                                        className="form-control mt-2"
                                                                        placeholder="No of years"
                                                                        value={
                                                                            exp.year
                                                                        }
                                                                        onChange={(
                                                                            e
                                                                        ) =>
                                                                            onExpYearChange(
                                                                                index,
                                                                                e
                                                                                    .target
                                                                                    .value
                                                                            )
                                                                        }
                                                                    />
                                                                )
                                                            )}
                                                        </div>
                                                    </div>
                                                    <div className="col-md-9">
                                                        <div className="form-group fieldDv">
                                                            <label htmlFor="field">
                                                                Filed of
                                                                Experience (You
                                                                can Add upto 3)
                                                            </label>
                                                            <div className="add_fileds">
                                                                <div className="input_group">
                                                                    {experience.map(
                                                                        (
                                                                            exp,
                                                                            index
                                                                        ) => (
                                                                            <input
                                                                                key={`exp_field_${index}`}
                                                                                type="text"
                                                                                id="experience_field"
                                                                                className="form-control mt-2"
                                                                                placeholder="No of years"
                                                                                value={
                                                                                    exp.field
                                                                                }
                                                                                onChange={(
                                                                                    e
                                                                                ) =>
                                                                                    onExpFieldChange(
                                                                                        index,
                                                                                        e
                                                                                            .target
                                                                                            .value
                                                                                    )
                                                                                }
                                                                            />
                                                                        )
                                                                    )}
                                                                </div>
                                                                <div className="addMore_btn">
                                                                    <button
                                                                        type="button"
                                                                        onClick={
                                                                            addExp
                                                                        }
                                                                    >
                                                                        <FontAwesomeIcon
                                                                            icon={
                                                                                faPlus
                                                                            }
                                                                        />
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div> */}
                                                <div className="col-md-12">
                                                    <div className="form-group">
                                                        <label htmlFor="about">
                                                            Write Few lines to
                                                            let customers know
                                                            about yourself and
                                                            your experience as a
                                                            care giver
                                                        </label>
                                                        <input
                                                            type="text"
                                                            maxLength="400"
                                                            id="few_lines"
                                                            className="form-control"
                                                            placeholder="Write about you"
                                                            value={fewLines}
                                                            onChange={(e) =>
                                                                setFewLines(
                                                                    e.target
                                                                        .value
                                                                )
                                                            }
                                                        />
                                                        <span className="note">
                                                            400 Words Max
                                                        </span>
                                                    </div>
                                                </div>
                                                <div className="col-md-12">
                                                    <div className="form-group mb-0">
                                                        <label htmlFor="attachments">
                                                            Attach
                                                            Certificates/Diplomas/Degree
                                                            which shows (in case
                                                            of nursing Degree
                                                            from reputed
                                                            university will be
                                                            required)
                                                        </label>
                                                        <div className="files_flex">
                                                            <div className="custom-file">
                                                                <button
                                                                    type="button"
                                                                    onClick={() =>
                                                                        document
                                                                            .getElementById(
                                                                                "documents"
                                                                            )
                                                                            .click()
                                                                    }
                                                                >
                                                                    <FontAwesomeIcon
                                                                        icon={
                                                                            faPaperclip
                                                                        }
                                                                    />
                                                                    {/* <i
                                                                            className="fa fa-paperclip"
                                                                            aria-hidden="true"
                                                                        ></i> */}
                                                                    Upload Files
                                                                </button>
                                                                <input
                                                                    type="file"
                                                                    className="custom-file-input"
                                                                    id="documents"
                                                                    multiple
                                                                    onChange={
                                                                        onDocsChange
                                                                    }
                                                                />
                                                            </div>
                                                            <ul
                                                                id="fileList"
                                                                className="file-list"
                                                            >
                                                                {documents.map(
                                                                    (doc) => (
                                                                        <li
                                                                            key={
                                                                                doc.name
                                                                            }
                                                                        >
                                                                            {
                                                                                doc.name
                                                                            }
                                                                        </li>
                                                                    )
                                                                )}
                                                            </ul>
                                                        </div>
                                                    </div>
                                                    {/*<a*/}
                                                    {/*    href="/agreements/hold_harmless.pdf"*/}
                                                    {/*    className="btn btn-danger text-white ml-2"*/}
                                                    {/*    download*/}
                                                    {/*>*/}
                                                    {/*    <FontAwesomeIcon*/}
                                                    {/*        icon={faDownload}*/}
                                                    {/*    />*/}
                                                    {/*    &nbsp; Hold Harmless*/}
                                                    {/*    Agreemennt*/}
                                                    {/*</a>*/}
                                                    {/*<a*/}
                                                    {/*    href="/agreements/photo_release.pdf"*/}
                                                    {/*    className="btn btn-danger text-white ml-2"*/}
                                                    {/*    download*/}
                                                    {/*>*/}
                                                    {/*    <FontAwesomeIcon*/}
                                                    {/*        icon={faDownload}*/}
                                                    {/*    />*/}
                                                    {/*    &nbsp; Photo Release*/}
                                                    {/*    Agreemennt*/}
                                                    {/*</a>*/}
                                                </div>
                                                {/* <div className="col-md-12">
                                                        <div className="form-group pt-4 d-flex acceptPolicy">
                                                            <input
                                                                type="checkbox"
                                                                id="accept_privacy2"
                                                                value={
                                                                    privacyAccept2
                                                                }
                                                                onChange={(e) =>
                                                                    setPrivacyAccept2(
                                                                        e.target
                                                                            .checked
                                                                    )
                                                                }
                                                                // className="form-control"
                                                            />
                                                            <label
                                                                className="pl-2"
                                                                htmlFor="accept_privacy2"
                                                            >
                                                                By adding your
                                                                phone number,
                                                                you’re saying
                                                                it’s okay for us
                                                                to send you
                                                                service–related
                                                                text messages,
                                                                including
                                                                autodialed. You
                                                                can adjust these
                                                                settings anytime
                                                                on the
                                                                Notifications
                                                                Preferences
                                                                page. Reply HELP
                                                                for help and
                                                                STOP to
                                                                unsubscribe.
                                                                Message
                                                                frequency
                                                                varies. Message
                                                                and data rates
                                                                may apply. For
                                                                more, see our
                                                                Terms of Service
                                                                and Privacy
                                                                Statement.
                                                                <span className="req">
                                                                    *
                                                                </span>
                                                            </label>
                                                        </div>
                                                    </div> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="card">
                                    <div className="card-header" id="formsix">
                                        <h5 className="mb-0">
                                            <button
                                                type="button"
                                                className="btn btn-link"
                                                data-toggle="collapse"
                                                data-target="#formsevencollapse"
                                                aria-expanded="false"
                                                aria-controls="formsevencollapse"
                                            >
                                                <div className="care_dropdown">
                                                    <div className="header_bar">
                                                        <div className="icon_bar">
                                                            <h5 className="title">
                                                                Agreements
                                                            </h5>
                                                        </div>
                                                        <div className="ques">
                                                            <p></p>
                                                        </div>
                                                    </div>
                                                    <div className="drop">
                                                        <FontAwesomeIcon
                                                            icon={faAngleLeft}
                                                        />
                                                    </div>
                                                </div>
                                            </button>
                                        </h5>
                                    </div>
                                    <div
                                        id="formsevencollapse"
                                        className="collapse"
                                        aria-labelledby="formsix"
                                        data-parent="#accordionTwo"
                                    >
                                        <div className="card-body">
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <div className="form-group d-flex acceptPolicy">
                                                        <input
                                                            checked={
                                                                holdHarmlessAccept
                                                            }
                                                            type="checkbox"
                                                            id="accept_hold_harmless"
                                                            style={{
                                                                marginTop: 5,
                                                            }}
                                                            onClick={() =>
                                                                setHoldHarmlessModal(
                                                                    true
                                                                )
                                                            }
                                                            // value={
                                                            //     holdHarmlessAccept
                                                            // }
                                                            // onChange={(e) =>
                                                            //     setHoldHarmlessAccept(
                                                            //         e.target
                                                            //             .checked
                                                            //     )
                                                            // }
                                                            // className="form-control"
                                                        />
                                                        <label
                                                            className="pl-2"
                                                            htmlFor="accept_hold_harmless"
                                                        >
                                                            I accept the{" "}
                                                            <button
                                                                type="button"
                                                                onClick={() =>
                                                                    setHoldHarmlessModal(
                                                                        true
                                                                    )
                                                                }
                                                            >
                                                                Hold Harmless
                                                                Agreement
                                                            </button>
                                                            <span className="req">
                                                                *
                                                            </span>
                                                        </label>
                                                    </div>
                                                    <div className="form-group d-flex acceptPolicy">
                                                        <input
                                                            checked={
                                                                photoReleaseAccept
                                                            }
                                                            type="checkbox"
                                                            id="accept_photo_release"
                                                            style={{
                                                                marginTop: 5,
                                                            }}
                                                            onClick={() =>
                                                                setPhotoReleaseModal(
                                                                    true
                                                                )
                                                            }
                                                            // value={
                                                            //     photoReleaseAccept
                                                            // }
                                                            // onChange={(e) =>
                                                            //     setHoldHarmlessAccept(
                                                            //         e.target
                                                            //             .checked
                                                            //     )
                                                            // }
                                                            // className="form-control"
                                                        />
                                                        <label
                                                            className="pl-2"
                                                            htmlFor="accept_photo_release"
                                                        >
                                                            I accept the{" "}
                                                            <button
                                                                type="button"
                                                                onClick={() =>
                                                                    setPhotoReleaseModal(
                                                                        true
                                                                    )
                                                                }
                                                            >
                                                                Photo Release
                                                                Agreement
                                                            </button>
                                                            <span className="req">
                                                                *
                                                            </span>
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* </form> */}
                            </div>
                            <hr />
                        </section>

                        <div className="bottom_bar">
                            <div className="note">
                                <p>
                                    Note: service providers (e.g. sitters) must
                                    abide by applicable laws and regulations.{" "}
                                    <Link
                                        to="/privacy-policy"
                                        color={config.primaryColor}
                                    >
                                        Privacy Policy
                                    </Link>
                                </p>
                            </div>
                            <div className="button-group">
                                <button
                                    type="button"
                                    className="btn mr-1"
                                    onClick={() =>
                                        navigate(
                                            "/care-giver-registration-2?back=true"
                                        )
                                    }
                                >
                                    Back
                                </button>
                                <button
                                    className="btn"
                                    onClick={() => navigate("/")}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="btn ml-2"
                                    onClick={submit}
                                >
                                    Save &amp; Continue
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* <!-- Care Giver Registration Form --> */}
            <Modal show={holdHarmlessModal} size="lg">
                <ModalHeader>Agree Hold Harmless Agreement</ModalHeader>
                <ModalBody>
                    <div dangerouslySetInnerHTML={{ __html: holdHarmless }} />
                </ModalBody>
                <ModalFooter>
                    <button
                        type="button"
                        className="btn btn-danger"
                        onClick={() => {
                            setHoldHarmlessAccept(true);
                            setHoldHarmlessModal(false);
                        }}
                    >
                        Agree
                    </button>
                    <button
                        type="button"
                        className="btn btn-danger"
                        onClick={() => {
                            setHoldHarmlessAccept(false);
                            setHoldHarmlessModal(false);
                        }}
                    >
                        Decline
                    </button>
                </ModalFooter>
            </Modal>
            <Modal show={photoReleaseModal} size="lg">
                <ModalHeader>Agree Photo Release Agreement</ModalHeader>
                <ModalBody>
                    <div dangerouslySetInnerHTML={{ __html: photoRelease }} />
                </ModalBody>
                <ModalFooter>
                    <button
                        type="button"
                        className="btn btn-danger"
                        onClick={() => {
                            setPhotoReleaseAccept(true);
                            setPhotoReleaseModal(false);
                        }}
                    >
                        Agree
                    </button>
                    <button
                        type="button"
                        className="btn btn-danger"
                        onClick={() => {
                            setPhotoReleaseAccept(false);
                            setPhotoReleaseModal(false);
                        }}
                    >
                        Decline
                    </button>
                </ModalFooter>
            </Modal>
            <Footer />
        </>
    );
};

const mapStateToProps = (state) => ({
    auth: state.auth,
    states: state.states,
});

const mapDispatchToProps = (dispatch) => ({
    createProfile: async (payload) =>
        dispatch(await CreateProfileAction(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CareRegistration3);
